import axios from 'axios';
import {signedUserData} from "../../utils/user";

const log = require("loglevel").getLogger("databaseBackupsService");
log.setLevel("error");

export const removeSnapshot = (id, type, keepFinalBackup) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/database/backups/remove`, {id, type, keepFinalBackup})
		.then(async response => {
			const res = response.data.status;
			log.debug("databaseBackupsService -> removeSnapshot -> return");
			return res;
		})
		.catch(response => {
			log.debug("databaseBackupsService -> removeSnapshot -> error: ");
			log.debug(response);
			return null;
		});
};

export const snapshotToSandbox = (snapshotName) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/database/backups/snapshot-to-sandbox`, {snapshotName})
		.then(async response => {
			const res = response.data;
			log.debug("databaseBackupsService -> snapshotToSandbox -> return");
			return res;
		})
		.catch(response => {
			log.debug("databaseBackupsService -> snapshotToSandbox -> error: ");
			log.debug(response);
			return null;
		});
};

export const switchLiveDatabase = (id, type) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/database/backups/replace-live`, {id, type})
		.then(async response => {
			const res = response.data;
			log.debug("databaseBackupsService -> switchLiveDatabase -> return");
			return res;
		})
		.catch(response => {
			log.debug("databaseBackupsService -> switchLiveDatabase -> error: ");
			log.debug(response);
			return null;
		});
};

export const createSnapshot = (comments) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/database/backups/create-snapshot`, {comments})
		.then(async response => {
			const res = response.data.status;
			log.debug("databaseBackupsService -> createSnapshot -> return");
			return res;
		})
		.catch(response => {
			log.debug("databaseBackupsService -> createSnapshot -> error: ");
			log.debug(response);
			return null;
		});
};

export const uploadData = async (config, file, mappedFields, onlyValidate) => {
	const relevantFields = mappedFields.filter(f => f.fieldName !== 'ignore');
	const formData = new FormData();
	formData.append('file', file);
	formData.append('mappedFields', JSON.stringify(relevantFields));
	formData.append('config', JSON.stringify(config));
	formData.append('onlyValidate', onlyValidate);

	try {
		const user = JSON.parse(signedUserData());
		const customHeaders = {
			'Connact-Access': user.uid
		};

		const response = await fetch(`${process.env.REACT_APP_HOST_URL}/database/backups/data/upload`, {
			method: 'POST',
			body: formData,
			headers: customHeaders
		});

		if (!response.ok) {
			log.debug("databaseBackupsService -> uploadData -> error: ");
			log.debug(response);
			return response;
		}

		const data = await response.json();
		log.debug("databaseBackupsService -> uploadData -> result: ", data);
		return data;
	} catch (error) {
		log.debug("databaseBackupsService -> uploadData -> error: ");
		log.debug(error);
	}
};

export const loadSnapshots = () => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/database/backups/get`)
		.then(async response => {
			const res = response.data.data;
			log.debug("databaseBackupsService -> loadSnapshots -> return");
			return res;
		})
		.catch(response => {
			log.debug("databaseBackupsService -> loadSnapshots -> error: ");
			log.debug(response);
			return null;
		});
};

